import { Item, Toolbar } from "devextreme-react/toolbar";
import { useContext } from "react";
import NoteGrid from "../../../common/notes/components/NoteGrid";
import { PurchaseOrderContext } from "../context/PurchaseOrderContext";
import PurchaseOrderAddNoteButton from "./PurchaseOrderAddNoteButton";

export default function PurchaseOrderNotes() {

	const { order } = useContext(PurchaseOrderContext);

	return (
		<>
			<Toolbar className='button-toolbar note-button-toolbar'>
				<Item location={'before'}>
					<PurchaseOrderAddNoteButton />
				</Item>
			</Toolbar>
			<NoteGrid
				notes={order.details.notes}
			/>
		</>
	)
}
